import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            吃瓜视频
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            今日吃瓜视频精选，名场面回放与翻车合集
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <a
              key={i}
              href="#media"
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-primary-500 transition-colors duration-300">
                    <i className="ri-play-fill text-primary-500 group-hover:text-background-50 text-2xl md:text-3xl ml-1 transition-colors duration-300"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-foreground-950/70 text-background-50 text-xs whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-950 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}